const getOptionTargetElement = (option, blockNode) =>
  option.querySelector ? blockNode.querySelector(option.querySelector) : blockNode;

export default getOptionTargetElement;
